import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'

export const ContentWrapper = styled(Box)({
  minWidth: '600px',
  minHeight: '150px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
})

export const ButtonGroup = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignContent: 'flex-end',
  gap: '3px',
})
